/* eslint-disable react/no-array-index-key, consistent-return, @typescript-eslint/no-shadow, prettier/prettier, @typescript-eslint/no-unused-vars */
import React from 'react';
import { useStyletron } from 'baseui';
import { StyledTable, StyledHeadCell, StyledBodyCell } from 'baseui/table-grid';
import { IFrontendMapping } from '../../../utils/types';

interface FrontendTabProps {
	mappings: IFrontendMapping[];
}

const FrontendTab: React.FC<FrontendTabProps> = ({ mappings }) => {
	const [css] = useStyletron();

	if (!mappings?.length) {
		return (
			<div className={css({ padding: '24px', color: '#666' })}>
				No frontend mappings found. This config key is not exposed to the frontend.
			</div>
		);
	}

	return (
		<div className={css({ padding: '16px' })}>
			<StyledTable $gridTemplateColumns='1fr 1fr 1fr 1fr 1fr'>
				<StyledHeadCell>Config Field</StyledHeadCell>
				<StyledHeadCell>API Endpoint</StyledHeadCell>
				<StyledHeadCell>Transform Function</StyledHeadCell>
				<StyledHeadCell>Android Component</StyledHeadCell>
				<StyledHeadCell>Android Screen</StyledHeadCell>
				{mappings.map((mapping, idx) => (
					<React.Fragment key={idx}>
						<StyledBodyCell>
							<code className={css({ fontSize: '13px', color: '#276EF1' })}>{mapping.configResponseField}</code>
						</StyledBodyCell>
						<StyledBodyCell>
							<code className={css({ fontSize: '12px' })}>{mapping.apiEndpoint}</code>
						</StyledBodyCell>
						<StyledBodyCell>
							<code className={css({ fontSize: '12px' })}>{mapping.transformationFunction}</code>
						</StyledBodyCell>
						<StyledBodyCell>{mapping.androidComponent}</StyledBodyCell>
						<StyledBodyCell>{mapping.androidScreen}</StyledBodyCell>
					</React.Fragment>
				))}
			</StyledTable>
		</div>
	);
};

export default FrontendTab;
